import React from 'react'

import Text from 'admin/components/common/Text'
import { default as ValidationMessageComponent } from 'components/ui/ValidationMessage'

const ValidationMessage: React.FunctionComponent<any> = (props) => {
  const { error, children, ...otherProps} = props
  const message = error ? <Text>{`validation.${  error}`}</Text> : children
  return <ValidationMessageComponent {...otherProps}>
    {message}
  </ValidationMessageComponent>
}

export default ValidationMessage